<script lang="ts" setup>
import type { StaticPage } from '~/types/StaticPage';

const { selectedOffer } = storeToRefs(useCatalogStore());
const isShowSizeChartModal = ref(false);
const sizeChartPage = ref<StaticPage | null>(null);

watch(
  () => selectedOffer.value,
  async () => {
    if (selectedOffer.value.size_chart_simple_page) {
      const staticPageStore = useStaticPageStore();

      sizeChartPage.value = await staticPageStore.getStaticPageBySlug(
        selectedOffer.value.size_chart_simple_page.split('/').slice(6).join('/'),
        true,
      );
    }
  },
  { immediate: true },
);
</script>

<template>
  <section
    v-if="sizeChartPage"
    class="product-page__size-charts-block"
  >
    <button
      class="product-page__size-charts-btn"
      @click="isShowSizeChartModal = true"
    >
      Таблица размеров
    </button>

    <BaseModal
      v-model="isShowSizeChartModal"
      @close="isShowSizeChartModal = false"
    >
      <StaticPageConstructorBlocks
        :blocks="sizeChartPage.constructor"
        class="my-5"
      />
    </BaseModal>
  </section>
</template>

<style lang="scss" scoped>
.product-page {
  &__size-charts-block {
    @include screen-md {
      margin-top: -20px;
    }
  }

  &__size-charts-btn {
    align-self: flex-start;
    color: $hell-blue;
    font-size: $text-sm;
    text-decoration: underline;
    transition: color 0.2s;

    &:hover {
      color: $label-violet;
    }
  }
}
</style>
